module.exports = "<div class=\"or-users\">\n  <app-split-container [fixedWidth]=\"600\">\n    <div fluid>\n      <app-user-list (userSelectedForEdit)=\"showUserInfo($event)\"></app-user-list>\n    </div>\n    <div fixed>\n      <app-user-edit [selectedUser]=\"selectedUser\" (selectedUserChanged)=\"discard()\"></app-user-edit>\n    </div>\n  </app-split-container>\n</div>\n<!-- End of or-users -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/users/users.component.html
// module id = ./src/app/routes/users/users.component.html
// module chunks = 9